module.exports = __webpack_public_path__ + "img/2695-2.8e1e55bc.png";